/** @format */

import {ReactElement} from 'react';

import {Box} from '@mui/material';

import {Trans} from 'react-i18next';

import i18n from 'i18next';

import {buildFormatterObject} from 'helpers/numberHelpers';

import {HintIconTooltip} from 'pages/Home/Main/Project/components/HintIconTooltip';

import TooltipContent from './components/TooltipContent';
import {useSavings} from './hooks/useSavings';
import {SavingsWidgetProps} from './interfaces';
import {
  AmountText,
  MonthText,
  NotAvailableText,
  SubText,
  SubTextContainer,
  WidgetTitle,
  WidgetTooltip,
} from './styles';
import {WidgetContainer} from '../../styles';

const SavingsWidget = ({tooltipContent, tokenStatus}: SavingsWidgetProps): ReactElement => {
  const {data, error, loading} = useSavings();

  const renderContent = () => {
    if (error || !data || tokenStatus === 'NOT_READY') {
      return (
        <NotAvailableText>
          <Trans>Будет рассчитана позже</Trans>
        </NotAvailableText>
      );
    }

    const {currency, period} = data;

    const {format: formatCurrency} = buildFormatterObject(currency, i18n.language);

    const {value, currency: formattedCurrency} = formatCurrency(data.amount);

    return (
      <>
        <AmountText>
          {value}
          <Box component='span'>{formattedCurrency}</Box>
        </AmountText>
        <SubText>
          <Trans>или</Trans> {period}
        </SubText>
      </>
    );
  };

  const renderBottomInfo = () => {
    if (!data || data.status !== 'default' || loading) return null;

    const {monthAmount, monthLabel, currency} = data;

    const {format: formatCurrency} = buildFormatterObject(currency, i18n.language);

    if (monthAmount == null || !monthLabel) return null;

    const {value, currency: formattedCurrency} = formatCurrency(monthAmount);

    return (
      <MonthText>
        {value}
        {formattedCurrency} <Trans>за</Trans> {monthLabel}
      </MonthText>
    );
  };

  return (
    <WidgetContainer>
      <WidgetTitle>
        <Trans>Экономия</Trans>
      </WidgetTitle>
      <WidgetTooltip>
        <HintIconTooltip title={tooltipContent || <TooltipContent />} placement='top' />
      </WidgetTooltip>
      {renderContent()}
      <SubTextContainer>{renderBottomInfo()}</SubTextContainer>
    </WidgetContainer>
  );
};

export default SavingsWidget;
